import * as React from 'react'
import { Redirect, RouteComponentProps } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import Layout from '../../components/Layout/layout'
import { routes } from '../routes'
import { RootState } from '../../state/store'
import TaskStats from '../../components/customer/TaskStats'
import { authenticationSelector } from '../../state/modules/authentication'
import CustomerSelection, { CustomerStats } from './CustomerSelection'
import { Company } from '../../state/modules/companies/types'
import { companySelector } from '../../state/modules/companies'
import { Typography } from '@material-ui/core'

type OverviewCustomerProps = {
  loggedIn: boolean
  customers: Company[]
}

type ComponentProps = OverviewCustomerProps & RouteComponentProps<any>

/**
 * Page for Brutto-Betriebseinnahmen
 */
const TaskRevenuePage: React.SFC<ComponentProps> = ({ customers, location, match, loggedIn }) => {
  if (!loggedIn) {
    return <Redirect to="/" />
  }

  return (
    <Layout routes={routes} location={location}>
      <Typography variant={'display1'}>Kunden-Ertragsübersicht</Typography>
      <TaskStats />
      <CustomerSelection activeCustomerStat={CustomerStats.taskRevenue} customers={customers} />
    </Layout>
  )
}

const mapStateToProps = (state: RootState): OverviewCustomerProps => ({
  loggedIn: authenticationSelector.isAuthenticated(state),
  customers: companySelector.getCustomers(state),
})
// @ts-ignore
export default compose(connect(mapStateToProps))(TaskRevenuePage)
